<template>
  <div class="center">
    <form class="box">
      <div class="title">
        <h1>JSON ⇒ Excel/CSV 変換</h1>
        <p>JSONデータを変換して、ExcelもしくはCSVで出力します。</p>
      </div>
      <ul v-if="errors.length">
        <li v-for="(error, index) in errors" :key="index">{{ error }}</li>
      </ul>
      <div class="window">
        <table style="border-spacing: 10px; margin-top: 35px;">
          <tbody>
            <tr>
              <td>
                <div style="margin-right: 10px; font-weight: bold;">データ入力例</div>
                <div class="box1">
                  <div class="textarea-box">
                    <div class="margin15">データオブジェクトの例</div>
                    <textarea :value="sample2" class="textarea" disabled="true"></textarea>
                  </div>
                  <div class="textarea-box">
                    <div class="margin15">オブジェクト配列も対応</div>
                    <textarea :value="sample" class="textarea" disabled="true">
                    </textarea>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td >
                <div style="min-height: 360px;">
                  <div class="radio-div">
                    <div>
                      <input type="radio" name="type" value="Input" v-model="picked" class="checkbox" checked />
                      <span>直接入力する</span>
                    </div>
                    <div style="margin: 0 0 0 20px;">
                      <input type="radio" value="File" v-model="picked" class="checkbox" />
                      <span>ファイルで指定する</span><br>
                    </div>
                  </div>
                  <div class="margin-top15">
                    <textarea v-if="isInput == 'Input' || isInput == ''" v-model="inputJson" class="textarea"
                      style="padding-left: 10px;" :disabled="picked == 'File'"
                      :class="[picked == 'File' ? 'disabled' : '']">
                  </textarea>
                    <div v-if="isInput == 'File'" class="option2">
                      <input type="file" @change="handleFileChange" ref="fileInput" :disabled="picked == 'Input'">
                    </div>
                  </div>
                </div>
                <div class="button">
                  <button type="submit" class="bottun-font" @click.prevent=convertAndDownloadExcel>Excel</button>
                  <button type="submit" class="bottun-font" @click.prevent=convertAndDownloadcsv>CSV</button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="option">
        <p>開発言語：javascript</p>
        <p>開発言語フレームワーク：vue.js</p>
      </div>
    </form>
  </div>

  <div class="loading-overlay" v-if="isBusy">
    <div class="loading-message">
      <p>Loading...</p>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { writeFile, utils } from 'xlsx';


export default {
  data() {
    /**
    * @type {string|URL}  入力データ（Object, URL）
    */
    const inputJson = "";

    /**
     * @type {boolean}    ローディング用
     */
    const isBusy = false;

    /**
     * @type {0|1}        URL判定用
     */
    const judgeUrl = false;

    /**
     * @type {string[]}
     */
    const errors = [""];

    /**
    * @type {string|URL}  サンプルデータ（String, URL）
    */
    const sample = `
    [
      {
        "productId": "12345",
        "productName": "ノートパソコン",
        "quantity": 1,
        "price": 79999,
        "currency": "JPY"
      },
      {
        "productId": "67890",
        "productName": "ワイヤレスマウス",
        "quantity": 2,
        "price": 1500,
        "currency": "JPY"
      }
    ]
`;

    /**
    * @type {string|URL}  サンプルデータ（String, URL）
    */
    const sample2 = `
    {
      "city": "Tokyo",
      "temperature": 22,
      "unit": "Celsius",
      "conditions": "晴れ",
      "forecast": [
        {
          "date": "2024-12-06",
          "temperatureMin": 18,
          "temperatureMax": 24,
          "conditions": "晴れ"
        },
        {
          "date": "2024-12-07",
          "temperatureMin": 16,
          "temperatureMax": 22,
          "conditions": "曇り"
        }
      ]
    }
`;

    /**
    * @type {boolean}  サンプルデータ（String, URL）
    */
    const inputFileActive = false;

    /** ラジオボタン */
    const isPicked = "";

    return {
      inputJson,
      isBusy,
      judgeUrl,
      errors,
      sample,
      sample2,
      inputFileActive,
      picked: isPicked,
    };
  },
  computed: {
    textareaInput() {
      return this.inputJson != '' ? true : false
    },
    isInput() {
      return this.picked
    }
  },
  methods: {
    //ファイル選択時データ受け取り
    handleFileChange(event) {
      const file = event.target.files[0];
      this.inputFileActive = true;
      this.inputJson = ""
      if (file && file.type === 'application/json') {
        const reader = new FileReader();
        reader.onload = () => {
          this.inputJson = reader.result;
        };
        // ファイルの読み込みを開始
        reader.readAsText(file);
      } else {
        this.errors.push("無効なファイル形式です。正しいファイルを選択してください。");
      }
    },
    // オブジェクトかどうかを判定
    isObject(value) {
      return value !== null && typeof value === 'object';
    },

    // 配列JSONデータをCSVデータに変換
    convertArrayJsonToCsv(data) {
      const keys = Object.keys(data[0]);
      const csv = [keys.join(',')];

      data.forEach(item => {
        const row = keys.map(key => {
          let cell = item[key];
          if (typeof cell === 'object') {
            cell = JSON.stringify(cell);
            cell = '"' + cell.replace(/"/g, '""') + '"';
          }
          return cell;
        });
        csv.push(row.join(','));
      });

      return csv.join('\n');
    },

    // 入力データの検証
    dataCheck() {
      this.errors = [];
      const urlPattern = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/;

      if (!urlPattern.test(this.inputJson) && this.isObject(this.inputJson)) {
        this.errors.push("無効なデータです。正しいデータを入力してください。");
        this.isBusy = false;
        return;
      } else if (urlPattern.test(this.inputJson)) {
        this.judgeUrl = true;
      }
    },

    async getJsonData() {
      let jsonData = null;
      this.isBusy = true;
      this.judgeUrl = false;
      this.dataCheck();

      if (this.errors.length !== 0) {
        this.isBusy = false;
        return null;
      }

      if (this.judgeUrl) {
        try {
          const response = await axios.get(this.inputJson);
          jsonData = response.data;
        } catch (error) {
          this.errors.push("無効なデータです。正しいデータを入力してください。");
          this.isBusy = false;
          return null;
        }
      } else {
        try {
          jsonData = this.inputJson;
          jsonData = JSON.parse(jsonData);
        } catch (error) {
          this.errors.push("JSON データが無効です。正しい JSON データを入力してください。");
          this.isBusy = false;
          this.judgeUrl = false;
          return null;
        }
      }

      //jsonデータを配列で囲む
      if (!Array.isArray(jsonData)) {
        jsonData = [jsonData];
      }
      return jsonData;
    },

    // 現在の時刻の文字列を返す
    getStringNowDate() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');

      return `${year}${month}${day}${hours}${minutes}`;
    },

    // 入力データをエクセルファイルに変換してダウンロード
    async convertAndDownloadExcel() {
      let jsonData = await this.getJsonData();

      if (jsonData == null) return this.errors;
      for (var i = 0; i < jsonData.length; i++) {
        var entry = jsonData[i];
        for (var key in entry) {
          if (typeof entry[key] === "object") {
            entry[key] = JSON.stringify(entry[key]);
          }
        }
      }

      var ws = utils.json_to_sheet(jsonData);
      var wb = utils.book_new();

      const timestamp = this.getStringNowDate();
      const extension = '.xlsx';
      const fileName = `json_${timestamp}${extension}`;

      utils.book_append_sheet(wb, ws, "Sheet1");
      writeFile(wb, fileName);

      this.isBusy = false;
      this.judgeUrl = false;
      this.exflag = false;
    },

    // 入力データをCSVに変換してダウンロード
    async convertAndDownloadcsv() {
      let jsonData = await this.getJsonData();
      if (jsonData == null) return;

      const csvData = this.convertArrayJsonToCsv(jsonData);
      console.log([csvData]);
      const blob = new Blob([csvData], { type: 'text/csv' });
      const url = (window.URL || window.webkitURL).createObjectURL(blob);
      const a = document.createElement('a');
      const timestamp = this.getStringNowDate();
      const extension = '.csv';
      const fileName = `json_${timestamp}${extension}`;

      a.href = url;
      a.download = fileName;
      a.click();

      //初期化
      (window.URL || window.webkitURL).revokeObjectURL(url);
      this.isBusy = false;
      this.judgeurl = false;
    }
  }
}
</script>
<style scoped>
span {
  white-space: normal;
}

p {
  font-size: 15px;
  margin: 0;
  padding: 0;
}

table {
  text-align: left;
  line-height: 1.8;
  width: 100%;
  height: auto;
  border-collapse: collapse;
  border: 1px solid #dddddd;
  padding: 0px 0px 0px 0px;
  margin: 10px 0px 10px 0px;
}

td {
  text-align: left;
  background-color: #f7f7f7;
  border-top: 1px solid #dddddd;
  padding: 20px 55px;
  margin: 0px;
}

tbody tr:nth-of-type(3) td {
  border: none;
}

.box1 {

  display: flex;
}

.title p {
  margin: 0;
}

.option {
  padding: 20px 0px 50px;
}

.option2 {
  margin-left: 20px;
  display: flex;
}

.option p {
  margin: 0;
  padding: 0;
}

.center {
  display: flex;
  justify-content: center;
}

@media (max-width:780px) {
  .box1 {
    width: 100%;
    display: block !important;
  }

  .option2 {
    text-align: center;
    display: block !important
  }
}

.disabled {
  cursor: not-allowed;
}


.button {
  height: 40px;
  display: grid;
  grid-auto-columns: 100px;
  grid-auto-flow: column;
  justify-content: center;
  gap: 4rem;
  margin: 20px;
}

li {
  list-style: none;
  color: red;
}

.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
}

.loading-message {
  background: white;
  padding: 20px;
  border-radius: 5px;
  text-align: center;
}

@media (max-width: 500px) {
  .title {
    width: 100%
  }

  textarea {
    min-width: 300px;
    max-width: 400px !important;
  }
}

.font {
  font-size: 15px;
  color: #fff;
  padding: 10px;
  margin-bottom: 0px;
  margin-top: 0px;
  margin-right: 0px;
  margin-left: 0px;
}

.textarea {
  box-sizing: border-box;
  border: 3px solid lightslategray;
  border-radius: 8px;
  height: 300px;
  width: 95%;
  margin: 0px 15px;

}

.bottun-font {
  font-size: 20px;
  font-family: math;
}

.text-align {
  margin: 5px;
  white-space: nowrap;
  text-align: center;
}

.toggle-switch {
  width: 45px;
  height: 20px;
  background-color: #ccc;
  border-radius: 30px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;
  transition: background-color 0.3s ease;
  margin: 3px;
}

.toggle-switch.on {
  width: 45px;
  height: 20px;
  background-color: #b9b8b8;
  border-radius: 30px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.switch {
  width: 17px;
  height: 16px;
  background-color: white;
  border-radius: 50%;
  margin: 2px;
  transition: transform 0.3s ease;
}

.switch.on {
  transform: translateX(25px);
  background-color: #b3ebb4;
  /* 緑色 */
}

.textarea-box {
  display: block;
  width: 90%;
}

.checkbox {
  margin-right: 5px;
}

.window {
  margin: auto;
  width: 800px;
}

@media (max-width:700px) {
  .window {
    width: 450px;
  }

  .radio-div {
    display: block !important;
  }

  .clear-botton {
    margin-left: 250px !important;
  }
}

.radio-div {
  display: flex;
}

.margin15 {
  margin-left: 15px;
}

.margin-top15 {
  margin-top: 15px;
}

.clear-botton {
  margin-left: 300px;
  padding: 0 10px;
}

.content-height {
  height: 400px;
  vertical-align: top;
}
</style>